<template>
  <div
    style="
      display: flex;
      height: 100%;
      overflow: hidden;
      padding: 0 20px 0 10px;
    "
  >
    <div class="flex flex-column" style="flex: 2; overflow-y: auto">
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        基本信息
      </div>
      <table class="invoice-detail-record-table" cellpadding="10">
        <tbody>
          <tr>
            <td>状态</td>
            <td>
              <c_status
                v-if="
                  state.model?.status != null &&
                  state.model?.status != undefined
                "
                arr-name="invoice_status"
                :value="state.model?.status"
              ></c_status>
            </td>
            <td>客户名称</td>
            <td>{{ state.model.customer_name }}</td>
          </tr>
          <tr>
            <td>发票类型</td>
            <td>{{ state.model.d_invoice_name }}</td>
            <td>发票抬头</td>
            <td>{{ state.model.title }}</td>
            <td>统一社会信用代码</td>
            <td>{{ state.model.s_unified_social_credit_identifier }}</td>
          </tr>
          <tr>
            <td>开票类型</td>
            <td>{{ state.model.d_invoice_type_name || "-" }}</td>
            <td>开票信息</td>
            <td>
              {{ state.model.invoice_nature == 0 ? "普通发票" : "增值税发票" }}
            </td>
            <td>开票种类</td>
            <td>{{ state.model.d_invoice_kind_name || "-" }}</td>
          </tr>
          <tr>
            <td>联系电话</td>
            <td>{{ state.model.contact_phone }}</td>
            <td>开票金额</td>
            <td colspan="2"><c_money :value="state.model?.amount" /></td>
          </tr>
          <tr>
            <td>申请说明</td>
            <td colspan="5">{{ state.model.invoice_remark || "-" }}</td>
          </tr>
        </tbody>
      </table>
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        开票日志
      </div>
      <div style="padding: 0 20px">
        <el-table
          ref="tableDom"
          :data="state.logData"
          v-loading="!Array.isArray(state.logData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            fixed
            label="#"
            width="50"
            type="index"
            align="center"
          />
          <el-table-column
            label="操作时间"
            prop="update_time"
            width="200"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            prop="remark"
            label="备注"
            :formatter="$tab_ShowToolTip"
            :min-width="150"
          />
          <el-table-column
            prop="content"
            label="内容"
            :formatter="$tab_ShowToolTip"
            :min-width="350"
          />
          <el-table-column label="操作人" width="200">
            <template #default="{ row }">
              <text>{{ row.add_admin_name }}</text>
              <text>{{ "/" + row.add_department_name }}</text>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="flex: 1">
      <div
        style="
          font-size: 13px;
          font-weight: 600;
          margin: 10px;
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
        "
      >
        审核信息
      </div>
      <el-form :model="state.model" ref="formDom" style="margin-left: 20px">
        <el-form-item label="审核状态">
          <c_status
            arrName="invoice_status"
            :value="state.model.status"
            v-if="state.model.id"
          />
        </el-form-item>
        <template v-if="state.model.status == 1">
          <el-form-item label="发票号">
            {{ state.model.invoice_number }}
          </el-form-item>
          <el-form-item label="开票日期">
            {{ state.model.invoice_date }}
          </el-form-item>
          <el-form-item label="开票备注">
            {{ state.model.check_remark || "-" }}
          </el-form-item>
          <el-form-item label="附件">
            <div style="width: 100%">
              <ul
                v-for="item in state.model.invoice_attachment"
                :key="item"
                class="diffbank-detail-files"
              >
                <li
                  style="color: #1e90ff; text-decoration: underline"
                  @click="toFile(item)"
                >
                  {{ item.filename }}
                </li>
              </ul>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="开票备注" v-else-if="state.model.status == 2">
          {{ state.model.check_remark || "-" }}
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { invoice_detail, invoice_log } from "@/http/api";
export default {
  props: {
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
      files: [],
      checkModel: {
        status: true,
        files: [],
      },
    });
    onMounted(() => {
      if (props.id) {
        state.checkModel.id = props.id;
        onLoad();
      }
    });

    const onLoad = () => {
      invoice_detail(props.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
        }
      });

      invoice_log(props.id).then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          state.logData = res.data.data?.list;
        }
      });
    };

    const toFile = (item) => {
      window.open(item.file_url, "_blank");
    };

    return { state, toFile };
  },
};
</script>
<style scoped lang="less">
.invoice-detail-record-table {
  width: 100%;
  font-size: 14px;

  & > tr > td:first-child {
    width: 100px;
  }

  & td:nth-child(2n + 1) {
    color: #a2a2a2;
    text-align: right;
  }

  & td:nth-child(2n) {
    text-align: left;
  }
}

.diffbank-detail-files {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.7);

  &:hover {
    color: #a2a2a2;
  }
}
</style>
